import classNames from "classnames";

const SHIMMER_KEYFRAMES = `
@keyframes shimmer-sweep {
  0%      { transform: translateX(-150%) skewX(-20deg); opacity: 0; }
  1%      { transform: translateX(-150%) skewX(-20deg); opacity: 1; }
  24%     { transform: translateX(250%)  skewX(-20deg); opacity: 1; }
  27%     { transform: translateX(250%)  skewX(-20deg); opacity: 0; }
  27.01%  { transform: translateX(-150%) skewX(-20deg); opacity: 0; }
  100%    { transform: translateX(-150%) skewX(-20deg); opacity: 0; }
}
`;

interface ShimmerProps {
  className?: string;
}

export function Shimmer({ className }: ShimmerProps) {
  return (
    <>
      <style>{SHIMMER_KEYFRAMES}</style>
      <div className={classNames("absolute inset-0 pointer-events-none overflow-hidden", className)} aria-hidden>
        <div
          className="absolute top-0 left-0 h-full w-[40%] bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,0.08)_50%,transparent_100%)]"
          style={{ animation: "shimmer-sweep 4.5s linear infinite" }}
        />
      </div>
    </>
  );
}
